export function captureScreenshot() {
  const scene = window.APP.scene.object3D;  // A-Frame scene object
  const camera = window.APP.scene.querySelector('#viewing-camera').getObject3D('camera');
  const renderer = window.APP.scene.renderer;  // Three.js renderer

  renderer.render(scene, camera);
  const imgData = renderer.domElement.toDataURL();

  return imgData;
}